<template>
  <div class="scss-click-effect style-container scss-shadow-container mt-4">
    <div class="d-flex flex-row">
      <!-- Image -->
      <div class="w-25">
        <smart-image :imageURL="serviceImageURL" class="style-img" />
      </div>

      <!-- Content -->
      <div class="w-75 text-start p-3 d-flex flex-column style-content">
        <span class="scss-bold scss-overflow-text-style"
          >Service: {{ name }}</span
        >
        <span class="scss-overflow-text-style">{{ description }}</span>
        <span class="scss-bold scss-overflow-text-style" style="width: 80%"
          >Date: {{ convertDateFormat(date) }}
        </span>
        <span class="scss-bold scss-overflow-text-style" style="width: 80%"
          >Time: {{ durationOfService }}
        </span>
        <span class="scss-bold scss-overflow-text-style" style="width: 70%"
          >Duration: {{ formatMinutesUpperCase(duration) }}</span
        >
        <span class="scss-bold scss-overflow-text-style" style="width: 70%"
          >Outlet: {{ branchName }}</span
        >
        <span class="scss-bold scss-overflow-text-style" style="width: 70%"
          >Booked: {{ staffName }}</span
        >
        <span class="scss-bold scss-overflow-text-style" style="width: 70%"
          >Status: {{ formatTicketStatus(status) }}</span
        >
        <span class="scss-bold scss-overflow-text-style" style="width: 70%">
          Transaction Status: {{ formatPaymentStatus(paymentStatus) }}
        </span>
      </div>

      <!-- Staff Image -->
      <div v-if="staffImageURL">
        <smart-image
          :imageURL="staffImageURL"
          class="style-staff-image rounded-circle"
        />
      </div>
    </div>
    <div class="style-error-message px-2 text-start" v-if="!isCwaOnlineBooking">
      *This appointment is booked in store, kindly contact the person in charge
      for any changes.
    </div>
  </div>
</template>

<script>
import {
  convertDateTimeToTimezone,
  formatMinutesUpperCase,
  addMinutesToTime,
  convertDateFormat,
} from "@/common/helpers/DateTimeHelper.js";
import SmartImage from "./SmartImage.vue";
import { dateTimeFormat } from "@/common/constant/DateTimeFormat";
import { ticketStatus } from "@/common/constant/TicketStatus";
import { paymentStatus } from "@/common/constant/PaymentStatus";

export default {
  name: "BookingListItem",
  components: { SmartImage },
  props: {
    serviceImageURL: String,
    name: String,
    date: String,
    duration: Number,
    staffName: String,
    staffImageURL: String,
    serviceImage: String,
    description: String,
    status: String,
    paymentStatus: String,
    branchName: String,
    isCwaOnlineBooking: Boolean,
  },
  computed: {
    durationOfService() {
      const timeInTimezone = convertDateTimeToTimezone({
        dateTime: this.date,
        outputFormat: dateTimeFormat.TIME_FORMAT,
      });
      return `${timeInTimezone} - ${addMinutesToTime(
        timeInTimezone,
        this.duration
      )}`;
    },
  },
  methods: {
    formatTicketStatus(status) {
      return ticketStatus[status];
    },
    formatPaymentStatus(status) {
      return paymentStatus[status];
    },
    formatMinutesUpperCase,
    convertDateFormat,
  },
};
</script>

<style lang="scss" scoped>
.style-container {
  border-top: 1px solid #dadada;
  width: 90%;
  margin: 0 auto 0 auto;
  height: fit-content;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.style-img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.style-content {
  font-size: 12px;
  line-height: 24px;
}

.style-staff-image {
  width: 48px;
  height: 48px;
  position: absolute;
  right: 10px;
  bottom: 10px;
  object-fit: cover;
}

.style-error-message {
  color: $error-color;
  font-size: 12px;
}
</style>
